<template>
  <div class="content" ref="container">
    <div class="list" v-for="(item, index) in list" :key="index">
      <div class="item" @click="toList(item.id)">
        <div class="answer">{{ item.create_time | time }}</div>
        <div class="name">
          共回答{{ item.count }}道问题,获得{{ item.points }}个积分
        </div>
      </div>
    </div>
    <Loading
      :loaded="loadend"
      :loading="loading"
      v-if="index > 0 && list.length > 0"
    ></Loading>
  </div>
</template>

<script>
import { getDatiRecord } from "@api/answer";
import Loading from "@components/Loading";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      page: 1,
      limit: 10,
      loadTitle: "",
      loading: false,
      loadend: false,
      list: [],
    };
  },
  filters: {
    time(val) {
      return new Date(parseInt(val) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
      /* let data = new Date(val);
      let y = data.getFullYear();
      var m = data.getMonth() + 1;
      var d = data.getDate();
      var h = data.getHours();
      var mm = data.getMinutes();
      let str = y + "-" + m + "-" + d + " " + h + ":" + mm;
      return data; */
    },
  },
  mounted() {
    this.getList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getList();
    });
  },
  methods: {
    toList: function (id) {
      this.$router.push({ path: "/answer/datiRecordList/" + id });
    },
    getList: function () {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      let q = {
        page: that.page,
        limit: that.limit,
      };
      getDatiRecord(q).then((res) => {
        that.loading = false;
        //apply();js将一个数组插入另一个数组;
        that.list.push.apply(that.list, res.data.list);

        that.loadend = res.data.list.length < that.limit; //判断所有数据是否加载完成；
        that.page = that.page + 1;
      });
    },
  },
};
</script>

<style>
.content {
  padding: 0.3rem;
}
.list .item {
  border-bottom: solid 1px #eeeeee;
  padding: 0.25rem 0;
}
.list .item .name {
  font-size: 0.3rem;
  font-weight: bold;
  margin-bottom: 0rem;
}
.list .item .option {
  font-size: 0.28rem;
  line-height: 0.6rem;
}
.list .item .answer {
  font-size: 0.28rem;
  color: #007faa;
  padding-bottom: 0.2rem;
}
</style>
